/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export default function createInitialSearchState() {
    const searchJson = window.localStorage.getItem('r1s_search_session');

    let searchInitialState;
    let initialState = {};

    try {
        searchInitialState = searchJson ? JSON.parse(searchJson) : null;

        if (searchInitialState) {
            // expire persisted search state if it's too old
            const ts = new Date(searchInitialState.last_updated_datetime);
            const expTime = new Date();
            expTime.setHours(expTime.getHours() - 4); // 4 hours ago
            if (ts < expTime || ts.getTime() > Date.now()) {
                searchInitialState = null;
                window.localStorage.removeItem('r1s_search_session'); // remove expired search state
            }
        }
    } catch {
        searchInitialState = null;
        window.localStorage.removeItem('r1s_search_session'); // remove invalid search state
    }

    if (searchInitialState) {
        initialState = { ...initialState, search: searchInitialState };
    }

    return initialState;
}
